<template>
  <div class="overflow-y-hidden betconsole-root american">
    <IllinoisHeader class="header-fixed" />

    <!-- ── Mobile navigation chrome ─────────────────────────────────────────── -->
    <template v-if="isVersionMobile && getEnableMobileBottomToolbar === false">
      <TopNavigationMobile />
    </template>
    <template v-if="isVersionMobile && getEnableMobileBottomToolbar === true">
      <MobileFooterFixed />
    </template>

    <!-- ── Desktop 3-column layout ───────────────────────────────────────────── -->
    <div v-if="!isVersionMobile" class="betConsole revengeBetConsole revengeGameConsole bc-layout">

      <!-- Left column (tree navigation) -->
      <div v-if="pageLayout.showLeft" class="bc-col-left" :class="leftColClass">
        <div :id="leftColId" ref="LeftHeight" class="col-scroll">
          <LeftModule />
          <!-- PrintOdds quick-access button — marketview + agency users only -->
          <div v-if="showPrintoddsButton" style="text-align: center">
            <button class="result-btn"
                    @click="changeLiveMode('printodds')"
                    :class="{ 'active-context': getViewMode === 'printodds' }"
                    :title="$t('printodds')">
              {{ $t('printodds') }}
            </button>
          </div>
        </div>
      </div>

      <!-- Center column (current page view) -->
      <div class="bc-col-center" :class="centerColClass">
        <div ref="CenterHeight" class="col-scroll center" :style="styleColScollCenter">
          <component :is="currentPageView" />
        </div>
      </div>

      <!-- Right column (bet-slip / cart) -->
      <div v-if="pageLayout.showRight " class="bc-col-right bordered-element pt-0 pl-1 pr-1">
        <div ref="RightHeight" class="col-scroll">
          <RightModule />
        </div>
      </div>

    </div>

    <!-- ── Mobile layout ─────────────────────────────────────────────────────── -->
    <v-container v-else-if="isVersionMobile"
                 fluid
                 class="betConsole revengeBetConsole revengeGameConsole"
                 :class="checkIsMobile() ? 'new-top-mobile' : 'new-top-tablet'">
      <v-row>
        <v-col cols="12" sm="12" md="12" class="bord-element">

          <!-- Live stream widget (top of mobile layout) -->
          <LiveStream v-if="getStreamLive" />

          <!-- Skin toolbar notificator (hidden but mounted for side effects) -->
          <SkinToolbarNotificator v-if="getGameConsole === 'classic'" style="display: none" />

          <!-- QBet overrides the normal page routing on mobile -->
          <template v-if="getQbet">
            <QuickBetDetailMobile />
          </template>

          <template v-else>
            <!-- Section wrapper: col-gap removes padding on home page -->
            <section :class="['container-center-mobile', currentPage === 'prematch_preview' && !isDetailTransition ? 'col-gap' : '']">
              <!-- Mobile search bar: shown only on home page when not in a loading transition -->
              <div class="container_search_settings" v-if="showMobileSearch">
                <GlobalEventSearch  />

<!--                <div v-if="isVersionMobile" class="vmt-trigger-wrap">-->
<!--                  <button class="vmt-trigger-btn" @click="viewModeModal = true">-->
<!--                    <v-icon>mdi-cog</v-icon>-->
<!--                  </button>-->
<!--                </div>-->
              </div>

              <!-- Active page view (same router as desktop) -->
              <component :is="currentPageView" />

            </section>

            <!-- Images widget: mobile-only addition shown when home page is idle -->
            <ImagesWidget v-if="currentPage === 'prematch_preview'" />
          </template>

          <!-- Fixed cart — always visible on mobile -->
          <FixedCart />

          <!-- Snackbar notifications -->
          <v-snackbar v-model="getSnackbar">
            {{ $t(getSnackbarText) }}
            <template v-slot:action="{ attrs }">
              <v-btn color="red darken-2" dark text v-bind="attrs" @click="closeSnackbar">
                {{ $t('close') }}
              </v-btn>
            </template>
          </v-snackbar>

          <!-- View mode selection modal -->
          <transition name="vmt-fade">
            <div v-if="viewModeModal" class="vmt-overlay" @click.self="viewModeModal = false">
            <div class="vmt-modal">
              <div class="vmt-modal-header">
                <span class="vmt-modal-title">{{ $t('event_view_mode_title') }}</span>
                <button class="vmt-close-btn" @click="viewModeModal = false">
                  <v-icon small>mdi-close</v-icon>
                </button>
              </div>
              <p class="vmt-modal-desc">{{ $t('event_view_mode_desc') }}</p>
              <div class="vmt-options">

                <!-- Compact option -->
                <div
                  class="vmt-option"
                  :class="{ 'vmt-option--active': getEventViewMode === 'compact' }"
                  @click="selectViewMode('compact')"
                >
                  <div class="vmt-option-label">
                    <v-icon x-small class="mr-1">mdi-view-list</v-icon>
                    {{ $t('event_view_compact') || 'Compact' }}
                    <v-icon x-small class="ml-auto vmt-check" v-if="getEventViewMode === 'compact'">mdi-check-circle</v-icon>
                  </div>
                  <!-- Skeleton: 3 compact rows, team names left, 3 odds chips right -->
                  <div class="vmt-preview">
                    <div class="vmt-sk-row" v-for="n in 3" :key="'c'+n">
                      <div class="vmt-sk-info">
                        <div class="vmt-sk-line" style="width:58%"></div>
                        <div class="vmt-sk-line" style="width:72%"></div>
                      </div>
                      <div class="vmt-sk-chips">
                        <div class="vmt-sk-chip"></div>
                        <div class="vmt-sk-chip"></div>
                        <div class="vmt-sk-chip"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Extended option -->
                <div
                  class="vmt-option"
                  :class="{ 'vmt-option--active': getEventViewMode === 'extended' }"
                  @click="selectViewMode('extended')"
                >
                  <div class="vmt-option-label">
                    <v-icon x-small class="mr-1">mdi-view-agenda</v-icon>
                    {{ $t('event_view_extended') || 'Extended' }}
                    <v-icon x-small class="ml-auto vmt-check" v-if="getEventViewMode === 'extended'">mdi-check-circle</v-icon>
                  </div>
                  <!-- Skeleton: 2 extended rows, info full-width then odds full-width below -->
                  <div class="vmt-preview">
                    <div class="vmt-sk-row-ext" v-for="n in 2" :key="'e'+n">
                      <div class="vmt-sk-info-ext">
                        <div class="vmt-sk-line" style="width:80%"></div>
                        <div class="vmt-sk-line" style="width:80%; margin-top:5px"></div>
                      </div>
                      <div class="vmt-sk-chips-ext">
                        <div class="vmt-sk-chip-wide"></div>
                        <div class="vmt-sk-chip-wide"></div>
                        <div class="vmt-sk-chip-wide"></div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <!-- ── Settings section ───────────────────────────────────── -->
              <div class="vmt-settings-divider"></div>
              <div class="vmt-settings">

                <!-- Odds Type accordion -->
                <div class="vmt-setting-row">
                  <span class="vmt-modal-title">{{ $t('oddsType') }}</span>
                  <p class="vmt-modal-desc mb-0">{{ $t('odds_type_desc') }}</p>
                  <div class="vmt-accordion">
                    <button
                      class="vmt-accordion-trigger"
                      :class="{ 'vmt-accordion-trigger--open': oddsTypeAccordionOpen }"
                      @click="oddsTypeAccordionOpen = !oddsTypeAccordionOpen"
                    >
                      <span>{{ $t(oddsTypes.find(t => t.value === oddsType).label) }}</span>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="vmt-acc-chevron">
                        <polyline points="6 9 12 15 18 9"/>
                      </svg>
                    </button>
                    <div class="vmt-accordion-list" v-show="oddsTypeAccordionOpen">
                      <div
                        v-for="type in oddsTypes"
                        :key="type.value"
                        class="vmt-accordion-item"
                        :class="{ 'vmt-accordion-item--active': oddsType === type.value }"
                        @click="oddsType = type.value; oddsTypeAccordionOpen = false"
                      >
                        <span>{{ $t(type.label) }}</span>
                        <v-icon x-small v-if="oddsType === type.value" class="vmt-acc-check">mdi-check</v-icon>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vmt-settings-divider"></div>


                <!-- Accept odds variation -->
                <div class="vmt-setting-row">
                  <span class="vmt-modal-title">{{ acceptOdds ? $t('acceptOddsShort') : $t('alwaysAskShort') }}</span>
                  <div class="flex">
                    <p class="vmt-modal-desc">{{ $t('accept_variations_desc') }}</p>

                    <label class="vmt-switch">
                      <input type="checkbox" v-model="acceptOdds">
                      <span class="vmt-slider"></span>
                    </label>
                  </div>

                </div>

              </div>

            </div>
            </div>
          </transition>

        </v-col>
      </v-row>
    </v-container>

    <!-- ── CartAmerican floating bottom sheet ────────────────────────────────── -->
    <template v-if="getGameConsole === 'american'">
      <div
        v-if="isCartOpen && getBet.odds.length > 0"
        class="cart-american-backdrop"
        @click="openOrCloseCart(false)"
      ></div>
      <CartAmerican
        v-if="getBet.odds.length > 0"
        ref="cartRef"
        :is-cart-open="isCartOpen"
        @toggle-cart="openOrCloseCart"
      />
    </template>

    <!-- ── BetDetailModal ────────────────────────────────────────────────────── -->
    <BetDetailModal
      :visible="showBetDetailModal"
      :bet="selectedBet"
      :loading="detailLoading"
      :cashout="cashout"
      :cashout-prematch="cashoutPrematch"
      @close="closeBetDetailModal"
      @cashout-success="handleBetDetailCashoutSuccess"
      @cashout-error="handleBetDetailCashoutError"
    />

    <!-- ── BetListModal ───────────────────────────────────────────────────────── -->
    <BetListModal
      :visible="showBetListModal"
      @close="showBetListModal = false"
    />

    <!-- ── Idle-session toast ─────────────────────────────────────────────────── -->
    <transition name="idle-toast-fade">
      <div v-if="idleModalEnabled && getModalIdle" class="idle-overlay">
        <div class="idle-toast"
             :class="isVersionMobile ? 'idle-toast--mobile' : 'idle-toast--desktop'">
          <div class="idle-toast__body">
            <span class="idle-toast__icon">⏱</span>
            <div class="idle-toast__text">
              <strong>{{ $t('idleTitleModal') }}</strong>
              <span>{{ $t('idleContentModal') }}</span>
            </div>
          </div>
          <button class="idle-toast__btn" @click="refreshIdle()">{{ $t('continue') }}</button>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import RightModule from '@/components/Right.vue'
import TopNavigationMobile from '@/components/center_widgets/TopNavigationMobile'
import MobileFooterFixed from '@/components/generic/MobileFooterFixed'
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'
import GlobalEventSearch from '@/components/generic/Search.vue'
import FixedCart from '@/components/center_widgets/FixedCart'
import ImagesWidget from '@/components/center_widgets/ImagesWidget'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import { checkIsMobileDevice, checkIsTabletDevice } from '@/plugins/device-inspector'
import { postToParent, PARENT_EVENTS } from '@/services/parentBridge/parentBridge'
import { PARENT_NAVIGATE_EVENT } from '@/services/parentBridge/parentCommands'

const SkinToolbarNotificator = () => ({
  component: import('@/components/generic/SkinToolbarNotificator'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const LiveStream = () => ({
  component: import('@/components/center_widgets/LiveStream'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const QuickBetDetailMobile = () => ({
  component: import('@/components/center_widgets/QuickBetDetail'),
  loading: LoadingSkeleton,
  timeout: 200,
})

// ── Page view components ───────────────────────────────────────────────────────
// Each page view is a thin wrapper around the existing section components.
// BetConsole owns the layout (column widths, left/right visibility);
// the page views own only the center content.
import PrematchPreviewPage from '@/views/sport/PrematchPreviewPage.vue'
import PrematchDetailPage  from '@/views/sport/PrematchDetailPage.vue'
import LiveListPage        from '@/views/sport/LiveListPage.vue'
import LiveDetailPage      from '@/views/sport/LiveDetailPage.vue'
import ResultPage          from '@/views/sport/ResultPage.vue'
import QBetPage            from '@/views/sport/QBetPage.vue'
import PrintOddsPage       from '@/views/sport/PrintOddsPage.vue'
import EventsDayPage       from '@/views/sport/EventsDayPage.vue'
import IllinoisHeader from "@/components/american/IllinoisHeader.vue";
import CartAmerican from "@/components/american/CartAmerican.vue";
import BetDetailModal from "@/components/american/BetDetailModal.vue";
import BetListModal from "@/components/american/BetListModal.vue";

const LeftModule = () => ({
  component: import('@/components/Left'),
  loading: LoadingSkeleton,
  timeout: 200,
})

// ── BetConsole-level page constants ───────────────────────────────────────────
const PAGES = {
  PREMATCH_PREVIEW: 'prematch_preview',
  PREMATCH_DETAIL:  'prematch_detail',
  LIVE_LIST:        'live_list',
  LIVE_DETAIL:      'live_detail',
  RESULT:           'result',
  QBET:             'qBet',
  PRINT_ODDS:       'printodds',
  EVENTS_DAY:       'list_events_day',
}

export default {
  name: 'TemplateAmerican',

  components: {
    IllinoisHeader,
    CartAmerican,
    BetDetailModal,
    BetListModal,
    RightModule,
    TopNavigationMobile,
    MobileFooterFixed,
    GlobalEventSearch,
    SkinToolbarNotificator,
    LiveStream,
    QuickBetDetailMobile,
    FixedCart,
    ImagesWidget,
    LeftModule,
    PrematchPreviewPage,
    PrematchDetailPage,
    LiveListPage,
    LiveDetailPage,
    ResultPage,
    QBetPage,
    PrintOddsPage,
    EventsDayPage,
  },

  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
    // legacy data props kept for any child that reads them via $parent (unlikely but safe)
    scrollPosition: 0,
    headerHeight: 0,
    topConsole: 0,
    heightCenter: 0,
    heightLeft: 0,
    heightRight: 0,
    ifInDetail: false,
    viewModeModal: false,
    oddsTypeAccordionOpen: false,
    isCartOpen: false,
    showBetDetailModal: false,
    showBetListModal: false,
    selectedBet: null,
    detailLoading: false,
    cashout: 0,
    cashoutPrematch: 0,
  }),

  computed: {
    ...mapGetters({
      'getBet':                    'cart/getBet',
      'getAuthenticated':          'user/getAuthenticated',
      'getViewMode':               'ui/getViewMode',
      'getEventsLiveDetail':       'detailLive/getEventsLiveDetail',
      'getEventsDetail':           'odds/getEventsDetail',          // todo: migrate to detailPrematch/getEventsDetail
      'getModalIdle':              'user/getModalIdle',
      'getSocketEnabled':          'socket/getSocketEnabled',
      'getEventStatscore':         'odds/getEventStatscore',
      'getGameConsole':            'settings/getGameConsole',
      'getEnableMobileBottomToolbar': 'settings/getEnableMobileBottomToolbar',
      'quickBetEnabled':           'settings/quickBetEnabled',
      'getCashier':                'user/getCashier',
      'getUserType':               'user/getType',
      'getTournamentsActive':      'previewPrematch/getTournamentsActive',
      'getEventsDetailActive':     'detailPrematch/getEventsDetailActive',
      'getEventsLiveDetailActive': 'detailLive/getEventsLiveDetailActive',
      'getLoadingDetail':          'detailPrematch/getLoadingDetail',
      'getLoadingPreview':         'odds/getLoadingPreview',
      'getPreview':                'previewPrematch/getPreview',
      'getQbet':                   'tree/getQbet',
      'getStreamLive':             'settings/getStreamLive',
      'getSnackbar':               'settings/getSnackbar',
      'getSnackbarText':           'settings/getSnackbarText',
      // ── Navigation state (used for browser history sync with parent) ─────────
      'currentNavPage':   'sportNavigation/currentPage',
      'currentNavParams': 'sportNavigation/currentParams',
      'getEventViewMode': 'ui/getEventViewMode',
      'getRulesManager':   'rules/getRulesManager',
      'getRulesSkin':      'rules/getRulesSkin',
      'getCashoutSetting': 'settings/getCashout',
      'getCashoutLive':    'settings/getCashoutLive',
      'getDetailMyBets':   'user/getDetailMyBets',
    }),

    styleColScollCenter(){

      let cls = 'padding: 30px'

      if (this.currentPage === PAGES.PREMATCH_DETAIL) {
        cls = 'padding: 0'
      }
      if (this.currentPage === PAGES.LIVE_DETAIL) {
        cls = 'padding: 0'
      }
      return cls
    },

    isExtendedView() {
      return this.isVersionMobile && this.getEventViewMode === 'extended';
    },

    oddsTypes() {
      const supported = this.$store.state.odds.supportedOddsFormats;
      if (supported && supported.length > 0) {
        return supported.map(f => typeof f === 'string' ? { label: f, value: f } : f);
      }
      const current = this.$store.state.odds.odds_type;
      return [{ label: current, value: current }];
    },

    oddsType: {
      get() { return this.$store.state.odds.odds_type; },
      set(value) { this.$store.commit('odds/SET_ODDS_TYPE', value); },
    },

    acceptOdds: {
      get() { return this.$store.state.cart.odds_variation; },
      set(value) { this.$store.commit('cart/SET_ODDS_VARIATION', value); },
    },

    // Combined navigation state — watched to emit SPORT_NAVIGATION_CHANGED
    _currentNavState() {
      return { page: this.currentNavPage, params: this.currentNavParams }
    },

    isVersionMobile() {
      return this.windowWidth < 1200 || window.forceMobileView === 'true'
    },

    idleModalEnabled() {
      return process.env.VUE_APP_ENABLE_IDLE_MODAL === '1'
    },

    // ── Mobile-specific transition flags ──────────────────────────────────────
    isDetailTransition() {
      return this.getLoadingDetail && this.getEventsDetail.length === 0
    },
    isPreviewTransition() {
      return this.getLoadingPreview && this.getPreview.length === 0 && this.getEventsDetail.length === 0
    },
    // Show mobile search bar only on the HomeView (not tournament, prelive, detail, etc.)
    showMobileSearch() {
      return (
          (this.$store.getters['sportNavigation/currentPage'] === 'home' || this.$store.getters['sportNavigation/currentPage'] === 'live_list') &&
        !this.isDetailTransition &&
        !this.isPreviewTransition
      )
    },

    // ── Core page resolver ────────────────────────────────────────────────────
    // Maps the existing state machine into explicit named pages.
    // Priority order (highest first):
    //   1. Live event detail is active
    //   2. Prematch event detail is active
    //   3. Live list section (viewMode='detail', no live detail)
    //   4. Prematch preview section (viewMode='preview', no prematch detail)
    //   5. Utility modes: result, qBet, printodds, list_events_day
    currentPage() {
      if (this.getEventsLiveDetail.length > 0)  return PAGES.LIVE_DETAIL
      if (this.getEventsDetail.length > 0 || (this.getEventsDetailActive && this.getEventsDetailActive.length > 0)) return PAGES.PREMATCH_DETAIL
      if (this.getViewMode === 'detail')          return PAGES.LIVE_LIST
      if (this.getViewMode === 'preview')         return PAGES.PREMATCH_PREVIEW
      // Utility modes pass through verbatim (result, qBet, printodds, list_events_day)
      return this.getViewMode
    },

    // ── Page → center component mapping ──────────────────────────────────────
    currentPageView() {
      const MAP = {
        [PAGES.PREMATCH_PREVIEW]: 'PrematchPreviewPage',
        [PAGES.PREMATCH_DETAIL]:  'PrematchDetailPage',
        [PAGES.LIVE_LIST]:        'LiveListPage',
        [PAGES.LIVE_DETAIL]:      'LiveDetailPage',
        [PAGES.RESULT]:           'ResultPage',
        [PAGES.QBET]:             'QBetPage',
        [PAGES.PRINT_ODDS]:       'PrintOddsPage',
        [PAGES.EVENTS_DAY]:       'EventsDayPage',
      }
      return MAP[this.currentPage] || 'PrematchPreviewPage'
    },

    // ── Column layout config per page ─────────────────────────────────────────
    pageLayout() {
      const isPrematch = (
        this.currentPage === PAGES.PREMATCH_PREVIEW ||
        this.currentPage === PAGES.PREMATCH_DETAIL
      )
      // Left column is shown for prematch (any game console) and for live detail.
      const showLeftPrematch = isPrematch && (
        this.getGameConsole === 'default' || this.getGameConsole === 'classic' || this.getGameConsole === 'american'
      )


      switch (this.currentPage) {
        case PAGES.PREMATCH_PREVIEW: return { showLeft: showLeftPrematch, showRight: false  }
        case PAGES.PREMATCH_DETAIL:  return { showLeft: showLeftPrematch, showRight: false  }
        case PAGES.LIVE_LIST:        return { showLeft: false,            showRight: true  }
        case PAGES.LIVE_DETAIL:      return { showLeft: false,             showRight: true  }
        case PAGES.RESULT:           return { showLeft: false,            showRight: false }
        case PAGES.QBET:             return { showLeft: false,            showRight: false  }
        case PAGES.PRINT_ODDS:       return { showLeft: false,            showRight: false }
        case PAGES.EVENTS_DAY:       return { showLeft: false,            showRight: false }
        default:                     return { showLeft: showLeftPrematch, showRight: false  }
      }
    },

    // ── Left column CSS classes ───────────────────────────────────────────────
    leftColClass() {
      const isMarketviewPrematch = (
        this.getGameConsole === 'classic' &&
        (this.currentPage === PAGES.PREMATCH_PREVIEW || this.currentPage === PAGES.PREMATCH_DETAIL)
      )
      return isMarketviewPrematch
        ? 'bordered-element pt-0 pl-0 pr-1 container-left-module'
        : 'bordered-element pt-0 pl-1 pr-1'
    },

    // id used by external CSS/JS that targets the marketview left container
    leftColId() {
      return (
        this.getGameConsole === 'classic' &&
        (this.currentPage === PAGES.PREMATCH_PREVIEW || this.currentPage === PAGES.PREMATCH_DETAIL)
      ) ? 'leftModuleV2Container' : undefined
    },

    // ── Center column CSS classes ─────────────────────────────────────────────
    centerColClass() {
      let cls = 'bordered-element pt-0 '
      if (this.currentPage === PAGES.PREMATCH_PREVIEW || this.currentPage === PAGES.PREMATCH_DETAIL) {
        cls += ' container-center-module'
      }
      if (this.currentPage === PAGES.LIVE_LIST || this.currentPage === PAGES.LIVE_DETAIL) {
        cls += ' container-center-module'
      }
      if (this.currentPage === PAGES.RESULT) {
        cls += ' result-detail'
      }
      return cls
    },

    // ── PrintOdds button visibility (marketview + agency/cashier users) ───────
    showPrintoddsButton() {
      return (
        this.getGameConsole === 'classic' &&
        (this.currentPage === PAGES.PREMATCH_PREVIEW || this.currentPage === PAGES.PREMATCH_DETAIL) &&
        this.quickBetEnabled === true &&
        (this.getUserType === '4' || this.getUserType === 4 || this.getCashier === true)
      )
    },
  },

  watch: {
    getLoadingDetail(val) {
      if (val) this._scrollCenterToTop()
    },
    getLoadingPreview(val) {
      if (val) this._scrollCenterToTop()
    },
    getEventsLiveDetail(val, old) {
      const newId = val[0]?.event?.id
      const oldId = old[0]?.event?.id
      if (newId !== oldId) this._scrollCenterToTop()
    },

    // ── Browser history sync ───────────────────────────────────────────────────
    // Ogni volta che la pagina o i parametri di navigazione cambiano, notifica
    // il parent via postMessage in modo che possa aggiornare il browser history.
    _currentNavState: {
      deep: true,
      handler() { this._emitNavigationChanged() },
    },
    getDetailMyBets: {
      deep: true,
      async handler(val) {
        if (this.showBetDetailModal && val && this.selectedBet) {
          this.selectedBet = val;
          await this.checkCashout(val);
          await this.checkCashoutPrematch(val);
        }
      },
    },
  },

  mounted() {
    // Flag non-reattivo: blocca il re-echo di SPORT_NAVIGATION_CHANGED quando
    // la navigazione è stata triggerata da un popstate del parent (anti-loop).
    this._fromHistory = false
    // Flag non-reattivo: sopprime SPORT_NAVIGATION_CHANGED durante i reset
    // (GO_TO_HOME / GO_TO_LIVE) per inviare al parent solo lo stato finale.
    this._navBatching = false
    // Ultimo slug inviato al parent — usato per la deduplicazione del watcher.
    this._lastEmittedSlug = null

    if (window.openlivesection === 'true' || window.openlivesection === true) {
      this.setViewMode({ mode: 'detail', section: 'live', skipHistory: true })
    }
    this._initDeepLink()
    this._restoreNavFromSession()
    window.addEventListener('message', this._onParentMessage)
    // Parent bridge: SPORT_NAVIGATE opens a tournament or an event in place (parentCommands)
    this._onParentNavigate = (slug) => {
      this._handleSlugNavigation(slug).catch(err => console.error('[ParentBridge] SPORT_NAVIGATE failed:', err))
    }
    this.$root.$on(PARENT_NAVIGATE_EVENT, this._onParentNavigate)
    window.addEventListener('resize', this._onResize)
    window.addEventListener('popstate', this._onIframePopstate)
    this.$root.$on('openBetDetailModal', this.openBetDetailModal)
    this.$root.$on('openBetListModal', this.openBetListModal)

    // Invia lo stato iniziale al parent così la skin ha sempre una baseline
    // history entry per il punto di partenza (es. home o live_list se openlivesection).
    // Usiamo nextTick per aspettare che i getter siano stabili dopo il mount.
    // Se c'è un deep-link in attesa (tournamentId/eventId), saltiamo l'emit iniziale:
    // manderemmo "home" prima che il fetch sia completato, facendo aggiornare il parent
    // con un URL errato. Il watcher _currentNavState invierà lo slug corretto non appena
    // il fetch completa e la navigazione si assesta sul torneo/evento richiesto.
    this.$nextTick(() => {
      if (!window.tournamentId && !window.eventId) {
        this._emitNavigationChanged()
      }
    })

    // Boot loader: rimosso quando il rendering si assesta (via updated + debounce).
    // Fallback di sicurezza: rimosso dopo 6s a prescindere.
    this._bootLoaderRemoved = false
    this._bootLoaderFallback = setTimeout(() => this._removeBootLoader(), 6000)
  },

  updated() {
    if (this._bootLoaderRemoved) return
    clearTimeout(this._bootSettleTimer)
    this._bootSettleTimer = setTimeout(() => this._removeBootLoader(), 400)
  },

  beforeDestroy() {
    window.removeEventListener('message', this._onParentMessage)
    this.$root.$off(PARENT_NAVIGATE_EVENT, this._onParentNavigate)
    window.removeEventListener('resize', this._onResize)
    window.removeEventListener('popstate', this._onIframePopstate)
    this.$root.$off('openBetDetailModal', this.openBetDetailModal)
    this.$root.$off('openBetListModal', this.openBetListModal)
    clearTimeout(this._bootLoaderFallback)
    clearTimeout(this._bootSettleTimer)
  },

  methods: {
    openOrCloseCart(value) {
      const wasOpen = this.isCartOpen;
      this.isCartOpen = typeof value === 'boolean' ? value : !this.isCartOpen;
      // Parent bridge: the desktop slip; the mobile one is posted by the store plugin (cart.mobileCartOpen)
      if (!this.isVersionMobile && this.isCartOpen !== wasOpen) {
        postToParent(PARENT_EVENTS.CART_STATE_CHANGED, { isOpen: this.isCartOpen });
      }
    },
    ...mapActions({
      'setSnackbar':               'settings/setSnackbar',
      'setModalIdle':              'user/setModalIdle',
      'socket_close':              'socket/socket_close',
      'socket_enable':             'socket/socket_enable',
      'fetchLiveV3ServerSide':     'previewLive/fetchLiveV3ServerSide',
      'fixture_change_live':       'socket/SOCKET_FIXTURE_CHANGE_LIVE',
      'odds_change_live':          'socket/SOCKET_ODDS_CHANGE_LIVE',
      'settlement_live':           'socket/SOCKET_SETTLEMENT_LIVE',
      'livescore_live':            'socket/SOCKET_LIVESCORE_LIVE',
      'new_event_live':            'socket/SOCKET_NEW_EVENT_LIVE',
      'place_bet_changed':         'socket/SOCKET_PLACE_BET_CHANGED',
      'setViewMode':               'ui/setViewMode',
      'setStatusQbet':             'tree/setStatusQbet',
      'fetchPreview':              'previewPrematch/fetchPreview',
      'fetchEventDetailV3':        'detailPrematch/fetchEventDetailV3',
      'fetchEventLiveDetailV5':    'detailLive/fetchEventLiveDetailV5',
      'removeFromPreview':         'previewPrematch/removeFromPreview',
      'removeFromDetail':          'detailPrematch/removeFromDetail',
      'removeEventLiveDetail':     'detailLive/removeEventLiveDetail',
      // Prelive panel actions (for slug navigation restore)
      'openTopsportsSport':           'topsports/openSport',
      'setTopsportsTab':              'topsports/setTabForSport',
      'ensureCategoryExpanded':       'topsports/ensureCategoryExpanded',
      'fetchTopsportsMixedPreview':   'topsports/fetchMixedPreview',
      'clearTopsportsMixedPreview':   'topsports/clearMixedPreview',
      'setSubaction':                 'ui/setSubaction',
      'goBack':                       'sportNavigation/goBack',
      'closeTopsportsPanel':          'topsports/closePanel',
      'clearNavHistory':              'sportNavigation/clearHistory',
      'setEventViewMode': 'ui/setEventViewMode',
      'setDetailMyBet':               'user/setDetailMyBet',
      'fetchCashout':                 'odds/fetchCashout',
      'fetchLiveScores':                'odds/fetchLiveScores',
    }),

    // ── Scroll management ─────────────────────────────────────────────────────
    _scrollCenterToTop() {
      this.$nextTick(() => {
        if (this.isVersionMobile) {
          window.scrollTo({ top: 0 })
        } else {
          const el = this.$refs.CenterHeight
          if (el) el.scrollTop = 0
        }
      })
    },

    // ── Resize handler ────────────────────────────────────────────────────────
    _onResize() {
      this.windowWidth = window.innerWidth
    },

    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },

    // ── Deep-link initialisation ──────────────────────────────────────────────
    _initDeepLink() {
      const isLive = window.openlivesection === 'true' || window.openlivesection === true

      if (window.eventId && isLive) {
        this.fetchEventLiveDetailV5({
          source:      window.eventId,
          sport:       window.sportId,
          tournament:  window.tournamentId,
          group:       0,
          eventName:   window.eventName,
          skipHistory: true,
        })
      } else if (window.eventId) {
        this.fetchEventDetailV3({
          source:          window.eventId,
          sport:           window.sportId,
          tournament:      window.tournamentId,
          competitorHome:  window.eventName || '',
          competitorAway:  '',
          eventName:       window.eventName,
          group:           null,
          skipHistory:     true,
        })
      } else if (window.tournamentId && window.sportId) {
        this.fetchPreview({
          source:              window.tournamentId + '#prematch',
          tournament:          window.tournamentId,
          type:                'previewOdds',
          sportId:             window.sportId,
          sportName:           window.sportName,
          tournamentName:      window.tournamentName,
          groupOddsWithSpreads: true,
          forceDefaultGameConsole: false,
          mobilePlatform:      this.checkIsMobile() || this.checkIsTablet(),
          skipHistory:         true,
        })
      }
    },

    // ── Iframe-native back navigation (popstate sulla window dell'iframe) ────
    // Viene triggerata quando il browser fa back su una entry pushata da noi
    // in _emitNavigationChanged. Funziona anche se il parent non invia openSlug.
    async _onIframePopstate(event) {
      if (!event.state || !event.state.betconsole) return
      // Evita doppio goBack se il parent invia openSlug in contemporanea.
      if (this._fromHistory) return
      this._fromHistory = true
      this._lastEmittedSlug = null  // reset per permettere re-emit dopo il back
      await this.goBack()
      await this.$nextTick()
      await this.$nextTick()
      this._fromHistory = false
    },

    // ── Parent postMessage handler (slug navigation / browser back-forward) ───
    async _onParentMessage(event) {
      if (!event.data || typeof event.data !== 'object') return
      if (event.data.type === 'openSlug') {
        // Evita doppio goBack se il popstate dell'iframe ha già gestito il back.
        if (this._fromHistory) return
        // La navigazione è originata da un back/forward del browser lato parent.
        // Chiamiamo goBack dello store che chiude la vista corrente e ripristina
        // la precedente, senza dover ricostruire lo stato dai parametri slug.
        this._fromHistory = true
        this._lastEmittedSlug = null  // reset per permettere re-emit dopo il back
        await this.goBack()
        await this.$nextTick()
        await this.$nextTick()
        this._fromHistory = false
      }
      if (event.data.type === 'GO_TO_LIVE') {
        // Reset in batch: il parent deve ricevere solo lo stato finale (live_list),
        // non gli stati intermedi generati durante la chiusura dei dettagli.
        this._navBatching = true
        try {
          // Chiude dettagli live e prematch aperti
          const liveIds = (this.getEventsLiveDetail || []).map(d => (d.event && d.event.id) || d.source).filter(Boolean)
          const detailSources = (this.getEventsDetail || []).map(d => d.source).filter(Boolean)
          for (const id of liveIds) await this.removeEventLiveDetail(id)
          for (const source of detailSources) await this.removeFromDetail({ source })
          // Torna alla home del live (live_list)
          await this.setViewMode({ mode: 'detail', section: 'live', skipHistory: true })
        } finally {
          this._navBatching = false
          this._emitNavigationChanged()
        }
      }
      if (event.data.type === 'GO_TO_HOME') {
        // Reset in batch: il parent deve ricevere solo lo stato finale (home).
        // Senza batch, chiudere un dettaglio live aperto dalla home (viewMode='detail')
        // passava per live_list: il parent rispondeva con un nuovo GO_TO_HOME e l'URL
        // oscillava tra page=home e page=live_list.
        this._navBatching = true
        try {
          const liveIds = (this.getEventsLiveDetail || []).map(d => (d.event && d.event.id) || d.source).filter(Boolean)
          const detailSources = (this.getEventsDetail || []).map(d => d.source).filter(Boolean)
          const previewSources = (this.getPreview || []).map(p => p.source).filter(Boolean)
          // Prima il viewMode: così il dettaglio live non degrada mai a live_list
          await this.setViewMode({ mode: 'preview', skipHistory: true })
          // Chiude tutti i dettagli live aperti (cleanup params / markets groups)
          for (const id of liveIds) await this.removeEventLiveDetail(id)
          // Chiude tutti i dettagli prematch aperti
          for (const source of detailSources) await this.removeFromDetail({ source })
          // Chiude tutti i preview di torneo aperti
          for (const source of previewSources) await this.removeFromPreview({ source })
          // Chiude il pannello prelive (topsports) se aperto
          await this.closeTopsportsPanel()
          // Azzera la history di navigazione interna
          await this.clearNavHistory()
        } finally {
          this._navBatching = false
          this._emitNavigationChanged()
        }
      }
    },

    // ── History sync helpers ──────────────────────────────────────────────────

    /** Costruisce lo slug di navigazione corrente dai getter di sportNavigation. */
    _buildNavSlug() {
      const page   = this.currentNavPage
      const params = this.currentNavParams || {}
      return {
        page,
        sportId:        params.sportId        || null,
        tournamentId:   params.tournamentId   || null,
        eventId:        params.eventId        || null,
        categoryId:     params.categoryId     || null,
        sportName:      params.sportName      || null,
        tournamentName: params.tournamentName || null,
        eventName:      params.eventName      || null,
        isLive: page === 'live_detail' || page === 'live_list',
      }
    },

    /**
     * Invia SPORT_NAVIGATION_CHANGED al parent (skin) in modo che possa
     * chiamare pushState/replaceState e aggiornare il browser history.
     * Non viene inviato se:
     *  - non siamo in un iframe (window.parent === window)
     *  - la navigazione è stata originata da un popstate (_fromHistory)
     *  - pagina e parametri chiave non sono cambiati rispetto all'ultimo emit
     *    (evita spam di log/postMessage su aggiornamenti socket degli odds)
     * In ogni caso persiste lo slug in sessionStorage per il restore al refresh.
     */
    _removeBootLoader() {
      if (this._bootLoaderRemoved) return
      this._bootLoaderRemoved = true
      clearTimeout(this._bootLoaderFallback)
      clearTimeout(this._bootSettleTimer)
      this.$nextTick(() => {
        window.parent.postMessage({ type: 'SPORT_READY' }, '*')
        const el = document.getElementById('sport-boot-loader')
        if (el) el.remove()
      })
    },

    _emitNavigationChanged() {
      if (this._fromHistory || this._navBatching) return
      const slug = this._buildNavSlug()

      // Deduplicazione: salta se pagina e parametri chiave non sono cambiati.
      // Il watcher _currentNavState si attiva ad ogni aggiornamento socket
      // (nuova reference object da currentParams), ma la navigazione non è
      // realmente cambiata — evitiamo migliaia di log e postMessage inutili.
      const prev = this._lastEmittedSlug
      if (prev &&
          prev.page        === slug.page &&
          prev.eventId     === slug.eventId &&
          prev.tournamentId === slug.tournamentId &&
          prev.sportId     === slug.sportId) {
        return
      }

      const isNewPage = !prev || prev.page !== slug.page || prev.eventId !== slug.eventId
      this._lastEmittedSlug = slug


      // Persiste lo stato di navigazione per il ripristino al refresh
      try {
        if (slug.page && slug.page !== 'home') {
          sessionStorage.setItem('betconsole-nav-slug', JSON.stringify(slug))
        } else {
          sessionStorage.removeItem('betconsole-nav-slug')
        }
      } catch (e) {}

      // Push una entry nella history dell'iframe in modo che il browser back
      // attivi il popstate anche se il parent non invia openSlug.
      if (isNewPage && typeof window !== 'undefined') {
        history.pushState({ betconsole: slug }, '')
      }

      if (typeof window === 'undefined' || window.parent === window) return
      window.parent.postMessage({
        type: 'SPORT_NAVIGATION_CHANGED',
        slug,
      }, '*')
    },

    /**
     * Al mount, ripristina la navigazione salvata in sessionStorage
     * (es. dopo un refresh di pagina) se nessun attributo HTML ha già
     * specificato una destinazione.
     */
    _restoreNavFromSession() {
      try {
        const raw = sessionStorage.getItem('betconsole-nav-slug')
        if (!raw) return
        const slug = JSON.parse(raw)
        if (!slug || !slug.page || slug.page === 'home') return
        // Se gli attributi HTML hanno già impostato un deep-link, non sovrascrivere
        const hasDeepLink = window.eventId ||
                            window.tournamentId ||
                            window.openlivesection === 'true' ||
                            window.openlivesection === true
        if (hasDeepLink) return
        this._handleSlugNavigation(slug)
      } catch (e) {}
    },

    async _handleSlugNavigation({ sportId, tournamentId, eventId, categoryId, sportName, tournamentName, eventName, isLive, page }) {

      // ── Prelive panel restore ──────────────────────────────────────────────
      if (page === 'prelive_live' && sportId) {
        const detailSources = (this.getEventsDetail || []).map(e => e.source).filter(Boolean)
        detailSources.forEach(source => this.removeFromDetail({ source }))
        const previewSources = [...(this.getTournamentsActive || [])]
        previewSources.forEach(source => this.removeFromPreview({ source }))
        const liveSources = [...(this.getEventsLiveDetailActive || [])]
        liveSources.forEach(source => this.removeEventLiveDetail(source))
        this.clearTopsportsMixedPreview()
        await this.setViewMode({ mode: 'preview' })
        this.openTopsportsSport(sportId)
        this.setTopsportsTab({ sportId, tab: 'liveandnext' })
        this.setSubaction('prelive')
        return
      }
      if (page === 'prelive_competitions' && sportId) {
        const detailSources = (this.getEventsDetail || []).map(e => e.source).filter(Boolean)
        detailSources.forEach(source => this.removeFromDetail({ source }))
        const previewSources = [...(this.getTournamentsActive || [])]
        previewSources.forEach(source => this.removeFromPreview({ source }))
        const liveSources = [...(this.getEventsLiveDetailActive || [])]
        liveSources.forEach(source => this.removeEventLiveDetail(source))
        this.clearTopsportsMixedPreview()
        await this.setViewMode({ mode: 'preview' })
        this.openTopsportsSport(sportId)
        this.setTopsportsTab({ sportId, tab: 'competitions' })
        this.setSubaction('prelive')
        if (categoryId) this.ensureCategoryExpanded({ sportId, categoryId })
        return
      }
      if (page === 'prelive_tournament' && sportId && tournamentId) {
        const detailSources = (this.getEventsDetail || []).map(e => e.source).filter(Boolean)
        detailSources.forEach(source => this.removeFromDetail({ source }))
        const previewSources = [...(this.getTournamentsActive || [])]
        previewSources.forEach(source => this.removeFromPreview({ source }))
        const liveSources = [...(this.getEventsLiveDetailActive || [])]
        liveSources.forEach(source => this.removeEventLiveDetail(source))
        await this.setViewMode({ mode: 'preview' })
        this.openTopsportsSport(sportId)
        this.setTopsportsTab({ sportId, tab: 'competitions' })
        this.setSubaction('prelive')
        if (categoryId) this.ensureCategoryExpanded({ sportId, categoryId })
        this.fetchTopsportsMixedPreview({ tournamentId, sportId, categoryId, tournamentName: tournamentName || '' })
        return
      }

      // Live list: nessun evento/torneo specifico, solo sezione live
      if (page === 'live_list' || (isLive && !sportId && !tournamentId && !eventId)) {
        await this.setViewMode({ mode: 'detail', section: 'live', skipHistory: true })
        return
      }

      if (!sportId && !tournamentId && !eventId) {
        this._closeAllViews()
        return
      }

      if (eventId && isLive) {
        // Chiude eventuali dettagli prematch aperti
        const detailSources = (this.getEventsDetail || []).map(e => e.source).filter(Boolean)
        detailSources.forEach(source => this.removeFromDetail({ source }))

        if (!(this.getEventsLiveDetailActive || []).includes(String(eventId))) {
          await this.fetchEventLiveDetailV5({
            source:      eventId,
            sport:       sportId,
            tournament:  tournamentId,
            group:       0,
            eventName:   eventName || '',
            skipHistory: true,
          })
        } else {
          // Già in store: ripristina solo il viewMode corretto
          await this.setViewMode({ mode: 'detail', section: 'live', skipHistory: true })
        }
      } else if (eventId) {
        // Chiude eventuali dettagli live aperti
        const liveSources = [...(this.getEventsLiveDetailActive || [])]
        liveSources.forEach(source => this.removeEventLiveDetail(source))

        if (!(this.getEventsDetailActive || []).includes(String(eventId))) {
          await this.fetchEventDetailV3({
            source:         eventId,
            sport:          sportId,
            tournament:     tournamentId,
            competitorHome: eventName || '',
            competitorAway: '',
            eventName:      eventName || '',
            group:          null,
            skipHistory:    true,
          })
        } else {
          // Già in store: ripristina solo il viewMode corretto
          await this.setViewMode({ mode: 'detail', skipHistory: true })
        }
      } else if (tournamentId && sportId) {
        // Torna al livello torneo: chiude tutti i dettagli evento aperti
        const detailSources = (this.getEventsDetail || []).map(e => e.source).filter(Boolean)
        detailSources.forEach(source => this.removeFromDetail({ source }))

        const source = tournamentId + '#prematch'
        const viewModeBefore = this.getViewMode
        if (!(this.getTournamentsActive || []).includes(source)) {
          await this.fetchPreview({
            source,
            tournament:              tournamentId,
            type:                    'previewOdds',
            sportId,
            sportName:               sportName || '',
            tournamentName:          tournamentName || '',
            groupOddsWithSpreads:    true,
            forceDefaultGameConsole: false,
            mobilePlatform:          this.checkIsMobile() || this.checkIsTablet(),
            skipHistory:             true,
          })
          // The player moved elsewhere while the preview was loading (the restore after a
          // reload is not awaited): the newer choice wins
          if (this.getViewMode !== viewModeBefore) return
        }
        // A tournament is a prematch page: switch the view even when the preview had to be
        // loaded, and before closing the live details (from the live section the tournament
        // would stay behind the live list, and the page would pass through live_list)
        const liveSources = [...(this.getEventsLiveDetailActive || [])]
        await this.setViewMode({ mode: 'preview', skipHistory: true })
        liveSources.forEach(source => this.removeEventLiveDetail(source))
      }
    },

    _closeAllViews() {
      const detailSources = (this.getEventsDetail || []).map(e => e.source).filter(Boolean)
      detailSources.forEach(source => this.removeFromDetail({ source }))

      const previewSources = [...(this.getTournamentsActive || [])]
      previewSources.forEach(source => this.removeFromPreview({ source }))

      const liveSources = [...(this.getEventsLiveDetailActive || [])]
      liveSources.forEach(source => this.removeEventLiveDetail(source))

      this.setViewMode({ mode: 'preview' })
      window.parent.postMessage({ type: 'removeSlugs' }, '*')
    },

    // ── Idle session recovery ─────────────────────────────────────────────────
    async refreshIdle() {
      this.setModalIdle(false)
      const liveSources = [...(this.getEventsLiveDetailActive || [])]
      for (const source of liveSources) {
        await this.removeEventLiveDetail(source)
      }
      await this.fetchLiveV3ServerSide({ page: 1, limit: 100 })
      this.socket_enable()
    },

    // ── Utility mode switch ───────────────────────────────────────────────────
    changeLiveMode(mode) {
      this.setStatusQbet(false)
      this.setViewMode({ mode })
    },

    selectViewMode(mode) {
      this.setEventViewMode(mode);
      this.viewModeModal = false;
    },

    closeSnackbar() {
      this.setSnackbar(false)
    },

    checkIfInDetail() {
      if (this.getViewMode === 'detail' && this.getEventsLiveDetail.length > 0) {
        this.ifInDetail = true
      }
      if (this.getViewMode === 'preview' && this.getEventsDetail.length > 0) {
        this.ifInDetail = true
      }
    },

    // ── BetDetailModal ────────────────────────────────────────────────────────
    async openBetDetailModal(bet) {
      this.detailLoading = true;
      this.selectedBet = bet;
      this.showBetDetailModal = true;
      try {
        await this.checkCashout(bet);
        await this.checkCashoutPrematch(bet);
        if (bet.result === 'pending') {
          await this._attachLiveScores(bet);
        }
        this.setDetailMyBet(bet);
      } catch (error) {
        console.error('[TemplateAmerican] openBetDetailModal error:', error);
      } finally {
        this.detailLoading = false;
      }
    },
    closeBetDetailModal() {
      this.showBetDetailModal = false;
      this.selectedBet = null;
      this.cashout = 0;
      this.cashoutPrematch = 0;
    },
    handleBetDetailCashoutSuccess() {
      this.closeBetDetailModal();
    },
    handleBetDetailCashoutError() {},

    // ── BetListModal ──────────────────────────────────────────────────────────
    openBetListModal() {
      this.showBetListModal = true;
      this.openOrCloseCart(false);
    },

    // ── Cashout helpers ───────────────────────────────────────────────────────
    /**
     * Fills in live score and clock for each leg of a pending bet.
     *
     * Replaces a per-leg loop over `odds/fetchEventResultAndTimeDetail`, which hit
     * the legacy `POST /events/getlive/event`. That route no longer exists in
     * rocky-api — there is no `/events` router at all, only `/v3/events` — so every
     * one of those calls 404'd, the catch swallowed it, and the detail fell through
     * to the empty branch: no score, no minute, and N wasted round trips before the
     * modal opened.
     *
     * One batched `POST /v3/live-scores` instead, the same call the classic MyBets
     * has used since its own migration (`_fetchAndAttachLiveScores`). A 6-leg
     * multiple costs one request rather than six sequential ones.
     *
     * The shapes differ: the legacy answered
     * `livescore.Scoreboard.{Time, Results[].{Position, Value}}`, v3 answers
     * `scoreboard.{clock.seconds, results[].{position, value}}` — lowercase, and
     * raw seconds rather than a pre-divided time. `-1` is v3 for "clock not
     * running".
     *
     * Legs with no score are cleared rather than left alone, which is what the old
     * loop did: a leg that stops being live must not keep showing a stale minute.
     */
    async _attachLiveScores(bet) {
      if (!bet || !Array.isArray(bet.odds)) return;

      const eventIds = [...new Set(bet.odds.map(o => o && o.event_source).filter(Boolean))];
      if (eventIds.length === 0) return;

      const scoreMap = {};
      try {
        const res = await this.fetchLiveScores({ eventIds });

        (res && Array.isArray(res.data) ? res.data : []).forEach(item => {
          if (!item || item.eventId == null) return;
          const sb = item.scoreboard;
          if (!sb || !Array.isArray(sb.results)) return;

          const home = sb.results.find(r => String(r.position) === '1');
          const away = sb.results.find(r => String(r.position) === '2');
          if (!home || !away) return;

          const seconds = sb.clock && sb.clock.seconds;
          const running = seconds != null && String(seconds) !== '-1';

          scoreMap[String(item.eventId)] = {
            home: home.value,
            away: away.value,
            timeActual: running ? parseFloat(seconds) / 60 : null,
          };
        });
      } catch (e) {
        // Scores decorate the bet detail: never block opening it.
        console.error('[LiveScores] fetchLiveScores error:', e);
      }

      bet.odds.forEach((odd, index) => {
        const score = scoreMap[String(odd && odd.event_source)];
        this.$set(bet.odds, index, score
          ? {
            ...odd,
            show_time: true,
            time_actual: score.timeActual != null ? score.timeActual : -1,
            result_actual_home: score.home,
            result_actual_away: score.away,
          }
          : {
            ...odd,
            show_time: false,
            time_actual: '',
            result_actual_home: '',
            result_actual_away: '',
          });
      });
    },

    async checkCashout(bet) {
      if (bet.type === 'integral' || bet.type === 'system') { this.cashout = 0; return; }
      if (!this.getCashoutLive) { this.cashout = 0; return; }
      const rules_skin = this.getRulesSkin || [];
      const rules_manager = this.getRulesManager || [];
      let rule = rules_skin.find(r => r.detail && r.detail.context === 1 && r.type === 'percentage');
      if (!rule) rule = rules_manager.find(r => r.detail && r.detail.context === 1 && r.type === 'percentage');
      const pct = rule && rule.detail && rule.detail.value != null ? rule.detail.value : 0.97;
      const amount_real = Number(bet.amount_real);
      const applicabile = [];
      const moltiplicatore = [];
      for (let i = 0; i < bet.odds.length; i++) {
        const odd = bet.odds[i];
        const odd_value = Number(odd.outcome_odd_value_for_order);
        if (odd_value > 7) { this.cashout = 0; return; }
        try {
          const odds_instant = await this.fetchCashout({
            id: odd.event_source,
            outcome_id: odd.id_outcome,
            unique_id: odd.unique_id,
            ext_id: odd.ext_id
          });
          if (odds_instant && odds_instant.length > 0) {
            for (const item of odds_instant) {
              if (item.odds && item.odds.outcome && item.odds.outcome._attributes && item.odds.outcome._attributes.id === odd.id_outcome) {
                const odd_value_actual = item.status && item.status.odds || 0;
                const status_odd = item.status && item.status.status;
                const vincita = amount_real * odd_value;
                const vincita_nuova = (vincita * (1 / odd_value_actual) * pct) / amount_real;
                if (odd.type === 'live' && (status_odd === 1 || status_odd === 3) && bet.result === 'pending' && odd_value_actual <= 7) {
                  applicabile.push('true');
                  moltiplicatore.push(vincita_nuova);
                } else {
                  applicabile.push('false');
                }
              }
            }
          }
        } catch { applicabile.push('false'); }
      }
      if (!applicabile.includes('false') && moltiplicatore.length > 0) {
        const importo = moltiplicatore.reduce((a, b) => a * b, 1) * amount_real;
        this.cashout = importo > 0 ? Math.abs(importo) : 0;
      } else {
        this.cashout = 0;
      }
    },
    async checkCashoutPrematch(bet) {
      try {
        if (bet.type === 'integral' || bet.type === 'system') { this.cashoutPrematch = 0; return; }
        if (!this.getCashoutSetting) { this.cashoutPrematch = 0; return; }
        const rules_skin = this.getRulesSkin || [];
        const rules_manager = this.getRulesManager || [];
        const _find = (ctx, type) => {
          return rules_skin.find(r => r.detail && r.detail.context === ctx && r.type === type)
            || rules_manager.find(r => r.detail && r.detail.context === ctx && r.type === type);
        };
        const cashoutrisk = (_find(0, 'percentage') || {detail:{value:20}}).detail.value;
        const min_events = (_find(0, 'min_event') || {detail:{value:2}}).detail.value;
        const min_odds = (_find(0, 'min_odds') || {detail:{value:1.2}}).detail.value;
        const max_events = (_find(0, 'max_event') || {detail:{value:7}}).detail.value;
        if (bet.bet_context !== 'prematch' || bet.result !== 'pending') { this.cashoutPrematch = 0; return; }
        const nr_events = bet.odds.length;
        if (nr_events < min_events || nr_events > max_events) { this.cashoutPrematch = 0; return; }
        const perc_events = 100 / nr_events;
        const value_pct = 100 - (perc_events - (perc_events * cashoutrisk) / 100);
        const amount_real = Number(bet.amount_real);
        const date_now = new Date();
        const in_checkout = [];
        let evento_in_corso = false;
        for (const odd of bet.odds) {
          let odd_value = Number(odd.outcome_odd_value_for_order);
          if (odd_value < min_odds || odd.status_event !== 1) { this.cashoutPrematch = 0; return; }
          if (odd.defined && (odd.result || odd.half_won)) {
            in_checkout.push(odd.half_won ? odd_value / 2 : odd_value);
          } else if (!odd.defined && odd.time < date_now.getTime()) {
            evento_in_corso = true;
          }
        }
        if (in_checkout.length > 0 && !evento_in_corso) {
          const quota = in_checkout.reduce((a, b) => a * b, 1);
          const profitto = (amount_real * quota) - amount_real;
          const valore = (profitto * value_pct) / 100;
          const real_cashout = (profitto - Math.abs(valore)) + amount_real;
          this.cashoutPrematch = real_cashout > 0 ? Math.abs(real_cashout) : 0;
        } else {
          this.cashoutPrematch = 0;
        }
      } catch (e) {
        console.error('[TemplateAmerican] checkCashoutPrematch error:', e);
        this.cashoutPrematch = 0;
      }
    },
  },

  // ── vue-idle hooks ────────────────────────────────────────────────────────
  onIdle() {
    if (!this.idleModalEnabled) return
    if (this.getViewMode !== 'detail') return
    this.setModalIdle(true)
    this.socket_close()
  },

  onActive() {},
}
</script>

<style scoped>

/* ── Root container: max-width centrato ─────────────────────────────────────── */
.betconsole-root {
  max-width: 1920px;
  margin: 0 auto!important;
}

.betconsole-root.american{
  max-width: 1450px!important;
}

/* ── Desktop 3-column flex layout ───────────────────────────────────────────── */
.bc-layout {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  align-items: stretch;
}

.bc-col-left,
.bc-col-right {
  flex: 0 0 clamp(200px, 320px, 320px);
  width: clamp(200px, 320px, 320px);
  min-width: 0;
  overflow: hidden;
}

.american .bc-col-left {
  flex: 0 0 clamp(200px, 270px, 320px);
  width: clamp(200px, 270px, 320px);
  min-width: 0;
  overflow: hidden;
}


.american .bc-col-right {
  flex: 0 0 30%;
  width: 30%;
  min-width: 0;
  overflow: hidden;
}


.american .bc-col-left{
  border-right: 1px solid var(--hsla-1);
}

.bc-col-center {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

/* At large screens lock to exact design width */
@media (min-width: 1500px) {
  .bc-col-left,
  .bc-col-right { flex-basis: 320px; width: 320px; }

  .american .bc-col-left
  { flex-basis: 270px; width: 270px; }

  .american .bc-col-right { flex-basis: 30%; width: 30%; }
}

/* At smaller desktop screens shrink side columns further */
@media (max-width: 1024px) {
  .bc-col-left,
  .bc-col-right { flex-basis: clamp(160px, 18vw, 240px); width: clamp(160px, 18vw, 240px); }
}

/* ── Idle toast ─────────────────────────────────────────────────────────────── */
.idle-overlay {
  position: fixed;
  inset: 0;
  z-index: 9998;
  background: rgba(0, 0, 0, 0.55);
}
.idle-toast {
  position: fixed;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--bg-secondary, #1e1e2e);
  border: 1px solid var(--color-primary, #a37e2c);
  border-radius: 8px;
  padding: 12px 16px!important;
  box-shadow: 0 4px 20px rgba(0,0,0,0.5);
  max-width: 360px;
}
.idle-toast--desktop {
  bottom: 16px;
  right: 16px;
}
.idle-toast--mobile {
  bottom: 10px;
  left: 6px;
  right: 6px;
  max-width: 100%;
  border-radius: 8px;
}
.idle-toast__body {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
  min-width: 0;
}
.idle-toast__icon {
  font-size: var(--font-size-8xl);
  flex-shrink: 0;
}
.idle-toast__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: var(--font-size-3xl);
  color: var(--text-platform, #e0e0e0);
}
.idle-toast__text strong {
  font-size: var(--font-size-3xl);
  font-weight: 700;
  color: var(--color-primary, #a37e2c);
}
.idle-toast__btn {
  flex-shrink: 0;
  background: var(--color-primary, #a37e2c);
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 7px 16px;
  font-size: var(--font-size-3xl);
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s;
}
.idle-toast__btn:hover { opacity: 0.85; }
.cart-american-backdrop {
  position: fixed;
  inset: 0;
  z-index: 499;
  background: rgba(0, 0, 0, 0.5);
}
.idle-toast-fade-enter-active, .idle-toast-fade-leave-active { transition: opacity 0.3s, transform 0.3s; }
.idle-toast-fade-enter, .idle-toast-fade-leave-to { opacity: 0; transform: translateY(12px); }
/* ────────────────────────────────────────────────────────────────────────────── */

div.v-overlay.v-overlay--active.theme--dark > div.v-overlay__scrim {
  opacity: 0.86 !important;
}

/* ── Layout a 3 colonne con scroll indipendente ── */
.col-scroll {
  height: 100vh;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.col-scroll::-webkit-scrollbar { display: none; }

#leftModuleV2Container {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
#leftModuleV2Container::-webkit-scrollbar { display: none; }

/* ── View mode trigger button (mobile only) ───────────────────── */
.vmt-trigger-wrap {
  display: none;
}
@media (max-width: 600px) {
  .container_search_settings{
    padding: 10px 10px 0;
  }

  .vmt-trigger-wrap {
    display: flex;
    justify-content: flex-end;
    padding: 0 0 0 8px;
  }
  .vmt-trigger-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--hsla-1);
    cursor: pointer;
    transition: background 0.15s, transform 0.2s;
    touch-action: manipulation;
    flex-shrink: 0;
  }
  .vmt-trigger-btn:active { transform: scale(0.92); }
  .vmt-trigger-btn .v-icon { color: var(--text-platform) !important; font-size: var(--font-size-7xl) !important; }

}

/* ── View mode overlay + modal ───────────────────────────────────── */
.vmt-overlay {
  position: fixed;
  inset: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.vmt-fade-enter-active, .vmt-fade-leave-active { transition: opacity 0.2s ease; }
.vmt-fade-enter, .vmt-fade-leave-to { opacity: 0; }
.vmt-modal {
  background: var(--bg-body, #1e1e2e);
  border-radius: 16px 16px 0 0;
  padding: 20px 16px 90px;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow-y: auto;
}
.vmt-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}
.vmt-modal-title {
  font-size: var(--font-size-4xl);
  font-weight: 700;
  color: var(--text-platform);
}
.vmt-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  line-height: 1;
}
.vmt-close-btn .v-icon { color: var(--text-op-50-platform) !important; }
.vmt-modal-desc {
  font-size: var(--font-size-2xl);
  color: var(--text-op-50-platform);
  margin: 0 0 16px;
}
.vmt-options {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.vmt-option {
  border: 2px solid var(--border-color, #333);
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  background: var(--bg-card, #1a1a1a);
  display: flex;
  flex-direction: column;
  gap: 10px;
  touch-action: manipulation;
  user-select: none;
  width: 50%;
}
.vmt-option--active {
  border-color: var(--color-primary);
  background: var(--color-primary-op);
}
.vmt-option-label {
  display: flex;
  align-items: center;
  font-size: var(--font-size-md);
  font-weight: 700;
  color: var(--text-platform);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  gap: 3px;
}
.vmt-option-label .v-icon { color: var(--text-platform) !important; }
.vmt-check { color: var(--color-primary, #00c864) !important; }

/* ── Skeleton previews ───────────────────────────────────────────── */
.vmt-preview {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
/* Compact: info left + 3 chips right */
.vmt-sk-row {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 0;
  border-bottom: 1px solid rgba(255,255,255,0.05);
}
.vmt-sk-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.vmt-sk-line {
  height: 6px;
  background: rgba(255,255,255,0.12);
  border-radius: 3px;
}
.vmt-sk-chips {
  display: flex;
  gap: 3px;
  flex-shrink: 0;
}
.vmt-sk-chip {
  width: 22px;
  height: 22px;
  background: rgba(255,255,255,0.09);
  border-radius: 4px;
}
/* Extended: info stacked, then chips full-width below */
.vmt-sk-row-ext {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px 0;
  border-bottom: 1px solid rgba(255,255,255,0.05);
}
.vmt-sk-info-ext {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.vmt-sk-chips-ext {
  display: flex;
  gap: 3px;
}
.vmt-sk-chip-wide {
  flex: 1;
  height: 20px;
  background: rgba(255,255,255,0.09);
  border-radius: 4px;
}

@media (max-width: 600px) {
  /* ── Extended event row layout ──────────────────────────────── */
  .event-row--extended .col-info {
    flex-direction: column;
    align-items: stretch;
    height: auto;
    width: 100%;
    border-right: none;
    padding: 6px 10px;
    gap: 0;
  }
  .event-row--extended .meta-block {
    order: -1;
    width: 100%;
    min-width: unset;
    display: flex;
    align-items: center;
    gap: 6px;
    padding-bottom: 5px;
    border-bottom: 1px solid var(--border-color, #333);
    margin-bottom: 5px;
  }
  .event-row--extended .info-market-block {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .event-row--extended .competitors-block {
    flex-direction: row;
    justify-content: space-between;
    gap: 6px;
    font-size: var(--font-size-3xl);
  }
  .event-row--extended .team-name {
    flex: 1;
    min-width: 0;
  }
  .event-row--extended .team-name.away {
    flex-direction: row-reverse;
    text-align: right;
  }
  .event-row--extended .col-center {
    width: 100%;
    height: auto;
    min-height: 44px;
    border-right: none;
    border-top: 1px solid var(--border-color, #333);
  }
  .event-row--extended .col-more {
    display: none;
  }
}

/* ── Modal settings section ──────────────────────────────────────── */
.vmt-settings-divider {
  height: 1px;
  background: var(--border-color, #333);
  margin: 14px 0 12px;
}
.vmt-settings {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.vmt-setting-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}
.vmt-setting-label {
  font-size: var(--font-size-2xl);
  font-weight: 500;
  color: var(--text-op-50-platform);
}

/* Odds type accordion */
.vmt-accordion {
  width: 100%;
}
.vmt-accordion-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  background: var(--bg-card, #222);
  border: 1px solid var(--border-color, #333);
  border-radius: 6px;
  color: var(--text-platform);
  font-size: var(--font-size-2xl);
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s;
}
.vmt-accordion-trigger--open {
  border-color: var(--color-primary, #00c864);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.vmt-acc-chevron {
  transition: transform 0.2s;
  color: var(--text-op-50-platform);
  flex-shrink: 0;
}
.vmt-accordion-trigger--open .vmt-acc-chevron {
  transform: rotate(180deg);
}
.vmt-accordion-list {
  border: 1px solid var(--color-primary, #00c864);
  border-top: none;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}
.vmt-accordion-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  font-size: var(--font-size-2xl);
  color: var(--text-op-50-platform);
  cursor: pointer;
  transition: background 0.12s;
  background: var(--bg-card, #222);
}
.vmt-accordion-item + .vmt-accordion-item {
  border-top: 1px solid rgba(255,255,255,0.05);
}
.vmt-accordion-item:hover {
  background: var(--bg-card-hover, #2a2a2a);
  color: var(--text-platform);
}
.vmt-accordion-item--active {
  color: var(--text-platform);
  font-weight: 600;
}
.vmt-acc-check {
  color: var(--color-primary, #00c864) !important;
  flex-shrink: 0;
}

/* Toggle switch */
.vmt-switch {
  position: relative;
  width: 34px;
  height: 18px;
  flex-shrink: 0;
  cursor: pointer;
}
.vmt-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.vmt-slider {
  position: absolute;
  inset: 0;
  background: #444;
  border-radius: 20px;
  transition: 0.2s;
  cursor: pointer;
}
.vmt-slider::before {
  content: '';
  position: absolute;
  height: 12px;
  width: 12px;
  left: 3px;
  bottom: 3px;
  background: #fff;
  border-radius: 50%;
  transition: 0.2s;
}
.vmt-switch input:checked + .vmt-slider {
  background: var(--color-accent, #00c864);
}
.vmt-switch input:checked + .vmt-slider::before {
  transform: translateX(16px);
}

.container_search_settings{
  display: flex;
}
/* ── CLASSI DEL NUOVO HEADER ── */
.header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 200;
}

</style>
